export const palette = {
    primary: {
        50: '#fbf5ef',
        100: '#f5e7d8',
        200: '#e9cdb0',
        300: '#daae87',
        400: '#cd9a6c',
        500: '#c08960',
        600: '#b47c52',
        700: '#93643f',
        800: '#714c30',
        900: '#4a311f',
        main: '#b47c52',
        light: '#cd9a6c',
        dark: '#714c30',
        contrastText: '#ffffff',
    },
    secondary: {
        50: '#f7f6f3',
        100: '#eeebe5',
        200: '#dbd5ca',
        300: '#c3bbac',
        400: '#aca294',
        500: '#948a7b',
        600: '#817b70',
        700: '#675f55',
        800: '#4e483f',
        900: '#332f29',
        main: '#817b70',
        light: '#aca294',
        dark: '#4e483f',
        contrastText: '#ffffff',
    },
    success: {
        main: '#6b7a5e',
        light: '#8c9a7e',
        dark: '#4e5a44',
        contrastText: '#ffffff',
    },
    error: {
        main: '#a6453b',
        light: '#c97972',
        dark: '#7a2f28',
        contrastText: '#ffffff',
    },
    warning: {
        main: '#b98f3e',
        light: '#d0b06e',
        dark: '#8c6b2a',
        contrastText: '#ffffff',
    },
    background: {
        default: '#f4f0e9',
        paper: '#fdfbf7',
    },
    text: {
        primary: '#24231f',
        secondary: '#817b70',
        disabled: '#b3afa6',
    },
    divider: 'rgba(36, 35, 31, 0.12)',
};
